import { LogData } from "@rogoag/shared-ts/dist/logger";
import { API, Company, Job, JobReady } from "../../../api";
import { logger } from "../../../utilities/logger";
import { toast } from "react-toastify";
import { AuthUser } from "../../../api/common";

export async function getCompanies(userId: string): Promise<Company[]> {
	const user = await API.Data.Contacts.get.byId(userId);
	const companies = await API.Data.Companies.get.byContact(user);
	companies.sort((companyA, companyB) => {
		if (companyA.name === "Rogo AG" || companyA.name === "ROGO Software") return -1;
		if (companyB.name === "Rogo AG" || companyB.name === "ROGO Software") return 1;
		return companyA.name.localeCompare(companyB.name);
	});
	return companies;
}

export async function submitJobReadyForm(selectedJobs: Job[], user?: AuthUser): Promise<void> {
	if (selectedJobs) {
		if (selectedJobs.length > 0) {
			const jobsIds = selectedJobs.filter((j) => !!j).map((job) => job.id);
			const logData: LogData = {
				function: "MarkJobReadyPage.model.submitJobReadyForm",
				airtable_record_id: jobsIds.join(","),
				airtable_table: "Jobs",
			};
			logger.log("Submitting Job Ready form", logData);
			const jobReadyForm: Partial<JobReady> = {
				name: "",
				jobIds: jobsIds,
				submitter: user?.name ?? "",
			} as const;

			for (let i = 0; i < selectedJobs.length; i++) {
				// need to test this
				const job = selectedJobs[i];
				if (job?.isMarkedReady) {
					const ld = { ...logData };
					ld.airtable_record_id = job.id;
					logger.warning(
						`Job ${job.id} already marked as ready, but an additional Job Ready form is being attached`,
						ld,
					);
				}
			}

			await API.Data.JobsReady.create.one(jobReadyForm);
			logger.log("Job Ready form submitted successfully", logData);
			await API.Data.Jobs.update.many(selectedJobs, true);
			logger.log("Jobs updated successfully after marking as ready", logData);
		} else {
			toast.error("No jobs selected to mark as ready");
			throw new Error(`selectedJobs.length == 0`);
		}
	} else {
		toast.error("No jobs selected to mark as ready");
		throw new Error(`selectedJobs == undefined`);
	}
}
